import { getAuth, sendPasswordResetEmail } from "firebase/auth";

const auth = getAuth();

export const resetPassword = async (email: string): Promise<{status: boolean, message: string}> => {
    try {
        await sendPasswordResetEmail(auth, email);
        return {status: true, message: "E-mail de redefinição enviado!"};
    } catch (error) {
        console.error("Erro ao enviar e-mail:", error);
        return {status: false, message: (error as Error).message}
    }
};